module.exports = __webpack_public_path__ + "static/img/logo.97880586.png";